<template>
    <div  :class="baseerp+'div'" >
        <div class="  w100" >
            <div class="flex p-5-9 jcsb">
<!--                <div class="upload" @click="uploadFile">-->
<!--                    <input type="file" name="files" value="" id="uploadfile1"-->
<!--                           class="upload-input uploadfile1" @change="uploadFile"  >-->
<!--                    <el-button :class="baseerp+'div'" size="mini" >{{$t('billOfExchange_import_flow')}}</el-button>-->
<!--                </div>-->
                <div>
<!--                    <div style="position: relative;display: inline-block" >-->
<!--                        <input type="file" name="files" value="" id="uploadfile"-->
<!--                               ref="uploadclear"     class="upload-input uploadfile1" @change="uploadFile">-->
<!--                        <el-button  :class="baseerp+'div'" size="mini">{{$t('billOfExchange_import_flow')}}</el-button>-->
<!--                    </div>-->
                    <el-button  :class="baseerp+'div'" size="mini" @click="tsChange">{{$t('billOfExchange_import_flow')}}</el-button>
                    <el-button style="margin-left: 9px" :class="baseerp+'div'" size="mini" @click="clzkFun">{{$t('billOfExchange_process_payments')}}</el-button>
                </div>


                <div>
                    <el-select v-model="i_gsid" size="mini" @change="chooseGsFun" style="">
                        <el-option v-for="item in gsList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                    </el-select>
                    <el-select v-model="i_bzid" size="mini" style="">
                        <el-option v-for="item in bzList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                    </el-select>
                    <el-date-picker
                            style="width:210px; margin-right: 9px; margin-left: 9px;"
                            size="mini"
                            :clearable="false"
                            :unlink-panels="true"
                            v-model="searchTime"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            :start-placeholder="$t('form_start_date')"
                            :end-placeholder="$t('form_end_date')"
                            @change="dateChange">
                    </el-date-picker>
                    <!--                    <el-button class="marB10" @click="addNewFun" :class="baseerp+'btn'" size="mini">新增汇票</el-button>-->

                    <el-input style=" margin-left: 6px;width:200px;" v-model="search" :placeholder="$t('button_search_for')" clearable size="mini">
                        <el-button  slot="append" icon="el-icon-search"  size="mini" @click="searchFun" ></el-button>
                    </el-input>
                </div>


            </div>
            <div  style="width: 100%">
                 <el-table
                        class="mrt10"
                        ref="table"
                        size="mini"
                        :height="tableHeight"
                        border
                        :data="tableData"
                        :header-cell-style="{background:'#eef1f6',color:'#000'}"
                        :highlight-current-row="true"

                        style="width: 100%">
                    <el-table-column  :label="$t('form_serial_number')" align="center" type="index" width="50px"></el-table-column>
                    <el-table-column align="center"  :label="$t('billOfExchange_filename')" prop="vc_name" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center"  :label="$t('billOfExchange_file_download')" prop="vc_name" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <a
                                    :download="scope.row.vc_name"
                                    mce_href="#"
                                    :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+scope.row.vc_newname+',bankflow\'}','utf-8')">
                                <!--:herf="file"-->     {{scope.row.vc_name}}
                            </a>
                        </template>
                    </el-table-column>
                    <el-table-column align="center"  :label="$t('billOfExchange_type')" prop="vc_name" width="90" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.i_type==0?$t('billOfExchange_upload_data_processing'):scope.row.i_type==1?$t('billOfExchange_historical_data_processing'):''}}
                        </template>
                    </el-table-column>
                     <el-table-column align="center"  :label="$t('billOfExchange_upload_results')" prop="i_analysis_result" width="60" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.i_analysis_result==1?$t('state_success'):scope.row.i_analysis_result==-1?$t('state_failure'):''}}
                        </template>
                    </el-table-column>
                     <el-table-column align="center"  :label="$t('billOfExchange_processing_result')" prop="i_analysis_result" width="70" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.i_handle_result==1?$t('state_processed'):scope.row.i_handle_result==0?$t('state_unprocessed'):''}}
                        </template>
                    </el-table-column>
                     <el-table-column align="center"  :label="$t('billOfExchange_upload/processing_date')" prop="dt_uploadtime" width="90" show-overflow-tooltip></el-table-column>
                     <el-table-column align="center"  :label="$t('billOfExchange_uploader/processor_name')" prop="vc_uploader"width="100" show-overflow-tooltip></el-table-column>
                     <el-table-column align="center"  :label="$t('billOfExchange_incorrect_file_download')" prop="vc_name" show-overflow-tooltip>
                         <template slot-scope="scope">
                             <a
                                     :download="scope.row.vc_error_filename"
                                     mce_href="#"
                                     :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+scope.row.vc_error_filenewname+',bankflow\'}','utf-8')">
                                 <!--:herf="file"-->     {{scope.row.vc_error_filename}}
                             </a>
                         </template>
                     </el-table-column>
                     <!--                     <el-table-column align="center" label="操作" prop="f_txlv1"  show-overflow-tooltip>-->
<!--                         <template slot-scope="scope">-->
<!--                             <el-button type="text" @click="zuoFei">作废</el-button>-->
<!--                             <el-button type="text" @click="xiaZai">下载</el-button>-->
<!--                         </template>-->
<!--                     </el-table-column>-->
                </el-table>
                <el-pagination  style="margin-top: 10px;text-align: right"
                                background
                                @current-change="pageCurrentChange"
                                @size-change="sizeChange"
                                :page-sizes="[20,50,100]"
                                layout="total,sizes,prev, pager, next"
                                :current-page.sync="currentPage"
                                :total="total"
                                :page-size="pageSize">
                </el-pagination>
            </div>
<!--            <div v-if="ckys" class="ckys">-->
<!--                <ys-list :data="ysdata" @close="closeys"></ys-list>-->
<!--            </div>-->
        </div>
        <el-dialog
            class="cldialog"
            style="display: flex;justify-content: center;align-items: center;"
            width="70%"
            top="30"
            height="300"
            :title="$t('billOfExchange_import')"
            :visible.sync="daoruDialog"
            v-if="daoruDialog"
            :close-on-click-modal="false" @close="daoruClose"
    >
            <dao-ru :data="daoruData" @close="daoruClose"></dao-ru>
        </el-dialog>
        <el-dialog :title="$t('tips_prompt')" :visible.sync="tsDialog"
                   v-if="tsDialog"  width="50%"
                   :close-on-click-modal="false">
            <span>{{$t('billOfExchange_the_date_must_not_contain_use_the_format_yyyymmdd_for_naming')}}</span>
            <div class="center top">
                <div style="position: relative;display: inline-block" >
                    <input type="file" name="files" value="" id="uploadfile"
                           ref="uploadclear"     class="upload-input uploadfile1" @change="uploadFile">
                    <el-button type="primary" :class="baseerp+'div'" size="mini">{{$t('billOfExchange_continue_importing')}}</el-button>
                </div>
            </div>

        </el-dialog>
<!--        <el-dialog title="添加收款"-->
<!--                   width="50%"-->
<!--                   top="50px"-->
<!--                   class="minw840"-->

<!--                   v-if="dialogtreeVisibleW"-->
<!--                   :visible.sync="dialogtreeVisibleW"-->
<!--                   :modal-append-to-body="false"-->
<!--                   :close-on-click-modal="false">-->
<!--            <add-new  @close="addClose" :data="addData"></add-new>-->
<!--        </el-dialog>-->
<!--        <div class="contentLeft">-->
<!--            <reportdialog  ref="mydialog"  ></reportdialog>-->
<!--            <eDialog ref="eDialog" :activePage="activePage"></eDialog>-->
<!--        </div>-->
    </div>
</template>

<script>
    import * as API from "./api"
    import DaoRu from "./DaoRu";
    import AddNew from "./AddNew";
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";
    import reportdialog from "@/components/dialog"; // dialog
    import eDialog from "@/components/eDialog"; // dialog
    export default {
        name: "index",
        components: {AddNew,reportdialog,eDialog,DaoRu},
        data() {
            return {
                treespan:5,
                isright:true,
                tableHeight:0,
                baseerp:'',
                token:'',
                i_uid:'',
                file_url: '',
                baseApp:"",
                baseVersion:"",
                tableData:[],
                currentPage: 1,
                pageSize: 20,
                total:0,
                endDate:'',
                startDate:'',
                i_gsid:0,
                i_bzid:0,
                i_khid:null,
                searchTime:[],
                bzList:[],
                ckys:false,
                ysdata:{},
                dialogtreeVisibleW:false,
                addData:{},
                search:'',
                activePage:"report/res/spread.vue",
                gsList:[],
                ztList:[],
                status:0,

                //------------------------
                daoruDialog:false,
                daoruData:{},
                socket:null,
                tsDialog:false,
            }
        },
        watch: {

            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.token=sessionStorage.getItem("token");
            this.i_uid= sessionStorage.getItem("userid");
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_url = file_url;
            // this.getImportResults()
            this.getCompanyList()
            this.getDay()
            this.getDictList()
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-100

            },
            tsChange(){
                // console.log('11111')
                this.tsDialog=true
            },
            daoru(){
                this.daoruDialog=true
            },
            clzkFun(){
                this.daoruData.funtype='clzk'
                this.daoruData.i_bzid=this.i_bzid
                this.daoruData.i_gsid=this.i_gsid
                this.daoruDialog=true

            },
            daoruClose(type='back'){
                // this.$refs.uploadclear.value=null
                // console.log(this.$refs.uploadclear)
                this.daoruDialog=false
                this.fileName=''
                this.files=''
                if(type=='save'){
                    this.currentPage=1
                    this.getImportResults()
                }
            },
            chooseGsFun(val){
                let obj=this.gsList.find(o=>o.i_id==val);
                if(obj!==undefined){
                    this.vc_gsname=obj.vc_name;
                }
                let data={
                    i_gsid:this.i_gsid,
                    i_khid:this.i_khid,
                    vc_khname:this.vc_khname,
                    vc_gsname:this.vc_gsname,
                };
                this.$emit('click',data)
                this.currentPage=1
                this.getImportResults()
            },
            dateChange(){
                this.startDate=this.searchTime[0]
                this.endDate=this.searchTime[1]
                this.currentPage=1;
                this.getImportResults();
            },
            searchFun(){
                this.currentPage=1;
                this.getImportResults();
            },
            changeData(val){
                this.i_gsid=val.i_gsid
                this.i_khid=val.i_khid
                this.vc_khname=val.vc_khname
                this.vc_gsname=val.vc_gsname
                this.currentPage=1
                this.getImportResults()
                this.ysdata={
                    i_gsid:this.i_gsid,
                    i_khid:this.i_khid,
                }
            },
            addNewFun(){
                if(this.i_khid){
                    this.dialogtreeVisibleW=true
                    this.addData={
                        i_gsid:this.i_gsid,
                        i_khid:this.i_khid,
                        vc_khname:this.vc_khname,
                        vc_gsname:this.vc_gsname,
                        bzList:this.bzList,
                        // lxList:this.lxfilterList,
                    }
                }else{
                    this.$message.warning(this.$t('billOfExchange_please_select_to_add_an_account'))
                }

            },
            addClose(type='back'){
                this.dialogtreeVisibleW=false
                if(type=='save'){
                    this.currentPage=1
                    this.getImportResults()
                }

            },
            ckysFun(){
                this.ysdata={
                    i_gsid:this.i_gsid,
                    i_khid:this.i_khid,
                }
                this.ckys=true

            },
            closeys(){
                this.ckys=false
            },
            dcFun(){},
            async getImportResults(){
                let param={
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    endDate:this.endDate,
                    startDate:this.startDate,
                    i_gsid:this.i_gsid,
                    // i_khid:this.i_khid,
                    vc_search:this.search
                };
                let res=await API.getImportResults(param);
                if ( res.code == 1 ){
                    this.tableData=res.data.list
                    this.total=res.data.total;

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            cancelFun(row){
                this.$confirm(this.$t('billOfExchange_whether_to_continue_invalidation'),this.$t('tips_prompt'),{
                    confirmButtonText:this.$t('button_continue'),
                    cancelButtonText:this.$t('button_cancel'),
                    type:'warning'
                }).then(async()=>{
                    this.row=row
                    this.receivableCancel()
                }).catch(()=>{
                    this.$message({
                        type:'info',
                        message:this.$t('state_cancelled')
                    })
                })
            },
            async receivableCancel(){
                let param={
                    i_id:this.row.i_id
                };
                let res=await API.receivableCancel(param);
                if ( res.code == 1 ){
                    // this.currentPage=1
                    this.getImportResults()

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.getImportResults();
            },
            sizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                ///调用列表接口
                this.getImportResults();
            },
            getDay(){
                const date=new Date();
                const y=date.getFullYear()
                const m=(date.getMonth()+1).toString().padStart(2,'0');
                const d=date.getDate().toString().padStart(2,'0');
                this.startDate=y+'-'+m+'-'+'01'
                this.endDate=y+'-'+m+'-'+d
                this.searchTime=[ this.startDate,this.endDate]
            },

            async getCompanyList(){
                let param={
                    i_type:'0,2'
                };
                let res=await API.getCompanyList(param);
                if ( res.code == 1 ){
                    this.gsList=res.data;
                    if(this.gsList.length>0){
                        this.i_gsid=this.gsList[0].i_id
                        this.vc_gsname=this.gsList[0].vc_name
                        this.getImportResults()
                    }

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getDictList(){
                let param={
                    vc_type:'bz'
                };
                let res=await API.getDictList(param);
                if ( res.code == 1 ){
                    this.bzList=res.data;
                    if( this.bzList.length>0)this.i_bzid=this.bzList[0].i_id
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async uploadFile(value) {
                // this.daoruDialog=true
                // this.daoruData={
                //     fileName:'weishiwenjianmngiz',
                //     filenewName:'woshinewname'
                // }
                // return

                let that = this;
                let $files = value.target.files[0];
                this.files=$files
                let fileName = $files.name
                let typeList=['xls'];
                let type=fileName.split('.').pop().toLowerCase();
                if(!typeList.includes(type)){
                    that.$message.error(that.$t('tips_please_upload_the_file_in_the_correct_format'));
                    return;
                };
                // let arr=fileName.split('-')
                // let index=this.gsList.findIndex(gs=>gs.vc_sname==arr[0])
                // if(index!=-1){
                //     console.log('keyikeyi')
                //     return
                //
                // }else{
                //     that.$message.error('暂无权限')
                //     return
                // }
                if ($files) {
                    that.fileName = $files.name;
                    that.fileType = $files.type;
                    that.fileUrl = window.URL.createObjectURL(value.target.files[0]);
                } else {
                    that.fileName = "";
                    that.fileType = "";
                    that.fileUrl = "";
                }
                if (that.fileName) {
                    // console.log('uploadFile-----')

                    var fileId = 'uploadfile' + that.idNum;
                    var param = {
                        excelName:that.fileName,
                        i_bzid:that.i_bzid,
                        i_gsid:that.i_gsid,
                    };

                    let res = await API.validName(param);
                    if (res.code == 1) {
                        this.daoruDialog=true
                        this.tsDialog=false
                        this.daoruData=res.data
                        this.daoruData.funtype='drls'
                        this.daoruData.fileName=that.fileName
                        this.daoruData.i_bzid=that.i_bzid
                        this.daoruData.i_gsid=that.i_gsid
                        this.daoruData.files=that.files
                    } else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                        this.$refs.uploadclear.value=null

                    } else {
                        this.$refs.uploadclear.value=null

                        this.$message.error(res.message);

                    }

                }
            },

        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;
        /*align-items: center;*/
    }
    .center{
        text-align: center;
    }
    .top{
        padding-top: 20px;
    }
    .w100{
        width: 100%;
    }
    /deep/{
        .minw840 .el-dialog{
            min-width: 700px;
        }
        .el-table .cell{
            padding-right: 2px;
            padding-left: 2px;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }

    }

    .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
        color: white;
    }
    .dib{
        display: inline-block;
    }
    .ckys{
        width: 340px;
        display: inline-block;
        margin: 0 4px;
        border: 1px solid #DCDFE6;
    }
    .wi{
        width:inherit;
    }
    .w100-480{
        width: calc(100% - 350px);
    }
    .p-5-9{
        padding: 5px 9px;
    }
    .jcsb{
        justify-content: space-between;
    }
    .upload{
        display: inline-block;
        margin-left: 20px;
        width:70px;
        position: relative;
        .el-input{
            position: absolute;
            top: 0;
            /*width: 90%;*/
            opacity:0 ;
        }
        .el-button{
            position: absolute;
            top: 0;
        }
    }
    .upload-input {
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 100%;

    }
    .uploadfile1{
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 100%;
    }
</style>